<div
  class="modal-overlay"
  [class.active]="isActive"
  (click)="onCancel()">
  <div class="modal confirmation-modal" (click)="$event.stopPropagation()">
    <button type="button" class="close-modal" (click)="onCancel()">x</button>

    <div class="confirmation-content">
      <h2 class="modal-title" i18n>Confirm disguise bid</h2>

      <div class="warning-message">
        <svg xmlns="http://www.w3.org/2000/svg" height="22" viewBox="0 -960 960 960" width="22" fill="currentColor" aria-hidden="true">
          <path d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z"/>
        </svg>
        <div>
          <p class="warning-lead" i18n>
            To disguise this trait bid as a custom bid, the app will include random CryptoPunk token IDs from the Yuga Labs wallet in how the bid is presented (for example in previews and notifications).
          </p>
          <p i18n>
            Those IDs are used as decoys on the assumption that <strong>Yuga Labs will not accept bids on them</strong>, so holders of those punks are unlikely to see them as actionable offers against their NFTs.
          </p>
        </div>
      </div>

      <div class="actions">
        <span class="cancel-btn-wrapper">
          <button type="button" class="cancel-btn" i18n (click)="onCancel()">Cancel</button>
        </span>
        <span class="confirm-btn-wrapper">
          <button type="button" class="confirm-btn" i18n (click)="onConfirm()">Enable disguise bid</button>
        </span>
      </div>
    </div>
  </div>
</div>
